import { Action, Selector, State, StateContext } from '@ngxs/store';
import * as actions from './legacy-swedish-game.actions';
import { LegacySwedishPuzzleModel } from './legacy-swedish-game.model';
import { Injectable } from '@angular/core';
// @dynamic
@State<Array<LegacySwedishPuzzleModel>>({
  name: 'swedishGameStates',
  defaults: [],
})
@Injectable()
export class LegacySwedishGameState {
  private static filterGames(games, puzzleID, remove = true) {
    return games.filter((game) => (remove ? game.puzzleID !== puzzleID : game.puzzleID === puzzleID));
  }

  @Selector()
  static getPuzzleGameByID(state: LegacySwedishPuzzleModel[]) {
    return (puzzleID: string) => {
      const puzzleGame = LegacySwedishGameState.filterGames(state, puzzleID, false);
      if (puzzleGame.length) {
        return puzzleGame[0];
      }
      return null;
    };
  }

  @Action(actions.LegacyPersistUserInput)
  LegacyPersistUserInput(store: StateContext<Array<LegacySwedishPuzzleModel>>, action: actions.LegacyPersistUserInput) {
    const swedishPuzzles = store.getState();
    store.setState(this.persistUserInput(swedishPuzzles, action));
  }

  @Action(actions.LegacyInitSwedishGame)
  LegacyInitSwedishGame(
    store: StateContext<Array<LegacySwedishPuzzleModel>>,
    { payload }: actions.LegacyInitSwedishGame
  ) {
    const swedishGames = LegacySwedishGameState.filterGames(store.getState(), payload.puzzleID);
    store.setState(swedishGames.concat(payload));
  }

  // @Action(actions.SwedishGameMultiTabSync)
  // SwedishGameMultiTabSync(
  //   store: StateContext<Array<SwedishPuzzleModel>>,
  //   { payload }: actions.SwedishGameMultiTabSync
  // ) {
  //   store.setState(payload);
  // }

  private persistUserInput(puzzleGames, action) {
    // map returns new array
    return puzzleGames.map((puzzleGame) => {
      if (puzzleGame.puzzleID !== action.payload.puzzleID) {
        return puzzleGame;
      }
      return {
        userInput: action.payload.userInput,
        puzzleID: puzzleGame.puzzleID,
        solutionWord: puzzleGame.solutionWord,
      };
    });
  }
}
